/* @flow */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
// $FlowIgnore
import { connect } from 'react-redux';

import { setModal } from 'ducks/modal';
import Release from 'components/Release';
import Row from 'components/UIKit/Flex/Row';
import ReleaseButtonWF from 'components/buttons/workflow/ReleaseButton';

class ReleaseButton extends Component {
  static propTypes = {
    program: PropTypes.string,
    project: PropTypes.string,
    style: PropTypes.object,
    disabled: PropTypes.boolean,
    dispatch: PropTypes.func,
  };

  render(): React.Element {
    let { style, disabled, dispatch } = this.props;

    return (
      <Row>
        <ReleaseButtonWF
          disabled={disabled}
          style={{
            ...style
          }}
          // handleOnClick={() => dispatch(setModal({
          //   Component: () => <Release project={this.props.project} program={this.props.program} />,
          //   style: {
          //     content: {
          //       position: 'initial',
          //       bottom: 'auto',
          //       right: 'auto',
          //       left: 'auto',
          //       top: 'auto',
          //       width: '60rem'
          //     }
          //   }
          // }))}
        />
      </Row>
    );
  }
}

export default connect()(ReleaseButton);
